export function ReportContainer({ children }: { children: React.ReactNode }) {
  return (
    <table className="w-full">
      <thead>
        <tr>
          <td>
            <div className="header-space">&nbsp;</div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{children}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div className="footer-space">&nbsp;</div>
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
